import QuotationBlock from './QuotationBlock';

export default QuotationBlock;
